import { render, staticRenderFns } from "./PostsTable.vue?vue&type=template&id=5429892a&scoped=true&"
import script from "./PostsTable.vue?vue&type=script&lang=js&"
export * from "./PostsTable.vue?vue&type=script&lang=js&"
import style0 from "./PostsTable.vue?vue&type=style&index=0&id=5429892a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5429892a",
  null
  
)

export default component.exports